import React, { useEffect } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "aos/dist/aos.css";
import AOS from "aos";
import "react-accessible-accordion/dist/fancy-example.css";
import "./../../../HomePage/Faq/Faq.css";

const QatarFaqMain = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
    });
  }, []);
  return (
    <div className="faqMainContainer">
      <Accordion className="faqMainContent" allowZeroExpanded>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What is Qatar Attestation and why do I need it?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel className="faqPanel">
            <p>
              Qatar attestation is the process of validating documents issued in
              India for use in Qatar. This involves getting them authenticated
              by relevant Indian authorities and the Qatar Embassy
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How long does Qatar Attestation take in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Qatar attestation is necessary for legalizing documents such as
              educational certificates, marriage certificates, and birth
              certificates for purposes like employment, education, or family
              residency in Qatar.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What documents do I need for Qatar Attestation?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Generally required:
              <ul>
                <li> Original certificate</li>
                <li> Passport copy</li>
                <li> Marksheet copies (for degree)</li>
                <li> Authorization letter (if using agency)</li>
                <li> Visa copy (if applicable)</li>
              </ul>
              Some personal certificates may also require local municipal
              verification.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Is it safe to give my original certificates?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes—ONLY if you choose a Govt-approved, ISO-certified, and
              well-established attestation center. A genuine agency provides:
              <ul>
                <li> Acknowledgment receipt</li>
                <li> Secure packaging</li>
                <li> Full tracking</li>
                <li> Office verification</li>
              </ul>
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                {" "}
                Can Qatar Attestation be done without visiting the office?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes. Many agencies offer:
              <ul>
                <li> Free Home Pickup & Drop</li>
                <li> Doorstep document collection</li>
                <li> Online payment & tracking</li>
              </ul>
              This is convenient for working professionals and people outside
              central Bangalore.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What is the cost of Qatar Attestation in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Fees vary by document, processing speed, and required
              endorsements. Typical pricing ranges:
              <ul>
                <li>
                  {" "}
                  <b>Degree Attestation:</b> ₹4,500–₹11,000
                </li>
                <li>
                  {" "}
                  <b>Marriage/Birth Certificate:</b> ₹5,000–₹13,000
                </li>
                <li>
                  {" "}
                  <b> Commercial Documents:</b> ₹12,000–₹28,000
                </li>
              </ul>
              Always compare quotes and ask for an itemized breakup (State + MEA
              + Embassy fees).
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3> What are the steps involved in Qatar Attestation?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              A complete Qatar Attestation usually includes:
              <ul>
                <li>1. Home Pickup (optional)</li>
                <li>2. Notary Attestation</li>
                <li>3. State Attestation (HRD/SDM/Home Dept.)</li>
                <li>4. MEA Attestation (India)</li>
                <li>5. Qatar Embassy Attestation</li>
                <li>6. MOFA Attestation (Qatar – if required)</li>
              </ul>
              A good agency manages the entire chain end-to-end.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                Do I need MOFA Attestation in Qatar after embassy attestation?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes, for:
              <ul>
                <li> Employment visa stamping</li>
                <li> Family visa</li>
                <li> Company/organization procedures</li>
                <li> Academic admissions</li>
              </ul>
              Most employers in Qatar require both Embassy + MOFA.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How do I know if an attestation agency is trustworthy?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Check for:
              <ul>
                <li> Govt Approved</li>
                <li> Govt Approved</li>
                <li> Physical office in Bangalore</li>
                <li>
                  1000+ verified reviews or 20,000–30,000 documents processed
                </li>
                <li> Transparent pricing</li>
                <li> Online tracking</li>
                <li> Home pickup & drop</li>
                <li> Corporate/MNC clients</li>
              </ul>
              Agencies trusted by 30+ multinational companies are usually safer.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Can Qatar Attestation be done urgently or same-week?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes, agencies offer:
              <ul>
                <li> Express 5-day service</li>
                <li> Priority attestation</li>
                <li>This is helpful for:</li>
                <li> Urgent job offers</li>
                <li> Visa deadlines</li>
                <li> Immediate travel plans</li>
              </ul>
              Urgent service usually has an additional fee.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default QatarFaqMain;
